import { useState, useEffect } from 'react'
import { Navigation } from './components/navigation'
import { Header } from './components/header'
import { Features } from './components/features'
import { About } from './components/about'
import { Services } from './components/services'
//import { Gallery } from './components/gallery'
import { Testimonials } from './components/testimonials'
import { Patents } from './components/patents'
import { Contact } from './components/contact'
import JsonData from './data/data.json'
import SmoothScroll from 'smooth-scroll'
import { Peculiarities } from './components/peculiarities'

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
})

const App = () => {
  const [landingPageData, setLandingPageData] = useState({})
  useEffect(() => {
    setLandingPageData(JsonData)
  }, [])

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Testimonials data={landingPageData.Testimonials} />
      <About data={landingPageData.About} />
      <Features data={landingPageData.Features} />
      <Peculiarities data={landingPageData.Peculiarities} />
      <Services data={landingPageData.Services} />
      <Patents data={landingPageData.Patents} />
      <Contact data={landingPageData.Contact} />
    </div>
  )
}
//      <Gallery />

export default App
